import { Button } from "@mui/material";
import { styled } from "@mui/system";
export const StyledButton = styled(Button, {
    shouldForwardProp: (prop) => !["round", "color", "shadow", "py", "width", "fullWidth", "height"].includes(prop),
})(({ theme, round, color, shadow, py, width, fullWidth, height }) => {
    var _a, _b, _c;
    return ({
        position: "relative",
        width: width ? width : fullWidth ? "100%" : "auto",
        borderRadius: round ? "100px" : "10px",
        padding: `${py === "primary" ? theme.spacing(1) : theme.spacing(1.5)} ${theme.spacing(4)}`,
        textTransform: "inherit",
        border: "solid 1px",
        fontWeight: 600,
        "& .MuiCircularProgress-root": {
            width: "1.5rem",
            height: "1.5rem",
            marginRight: 10,
            color: "#696969",
        },
        borderColor: 
        //   ["primary", "secondary"].includes(color || "") 
        //     ? "transparent" 
        //     : color === "gradient"
        //     ? "#D2D8FF"
        // : 
        "#A2B0C1",
        background: 
        //  color === "gradient" ? 
        "linear-gradient(94.48deg, #FFFFFF 0%, #EBEDFA 100%)",
        //   : undefined,
        color: 
        //   (color === "gradient" && 
        (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a.main,
        // ) ||
        //   (color === "green" && theme.palette.green?.main),
        boxShadow: shadow ? "0px 7px 30px rgba(50, 78, 207, 0.5)" : "none",
        ":hover": {
            border: color === "secondary" ? `solid 1px ${(_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b.main}` : undefined,
            backgroundColor: color === "secondary" ? (_c = theme.palette.secondary) === null || _c === void 0 ? void 0 : _c.main : undefined,
            boxShadow: "none",
        },
        height: height ? height : "auto",
    });
});
